"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Header = void 0;
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var clsx_1 = __importDefault(require("clsx"));
function Header(_a) {
    var order = _a.order, onSortOrderChange = _a.onSortOrderChange, displayQueue = _a.displayQueue;
    var t = (0, react_i18next_1.useTranslation)().t;
    return (react_1.default.createElement("thead", null,
        react_1.default.createElement("tr", { className: "jobs-table-header-row" },
            react_1.default.createElement("th", { className: "jobs-table-header-cell jobs-table-header-preview" }, t('DASHBOARD.ITEM_LOG.TABLE.HEADER.CONTENT')),
            react_1.default.createElement("th", { className: "jobs-table-header-cell jobs-table-header-id" }, t('DASHBOARD.ITEM_LOG.TABLE.HEADER.ID')),
            react_1.default.createElement("th", { className: (0, clsx_1.default)({
                    header: true,
                    sortable: true,
                    'jobs-table-header-cell': true,
                    'jobs-table-header-date': true,
                    'sort-desc': order === 'DESC',
                    'sort-asc': order === 'ASC',
                }), onClick: function () { return onSortOrderChange(order === 'DESC' ? 'ASC' : 'DESC'); } },
                react_1.default.createElement("div", null,
                    react_1.default.createElement("span", { className: "ng-binding sort-indicator" }, t('itemLog:TABLE.HEADER.RECEIVED_AT')))),
            react_1.default.createElement("th", { className: "jobs-table-header-cell jobs-table-header-rules" }, t('itemLog:TABLE.HEADER.DECISION_RULES')),
            react_1.default.createElement("th", { className: "jobs-table-header-cell jobs-table-header-status" }, t('itemLog:TABLE.HEADER.STATUS')),
            displayQueue && react_1.default.createElement("th", { className: "jobs-table-header-cell jobs-table-header-queue" }, t('itemLog:TABLE.HEADER.QUEUE')))));
}
exports.Header = Header;
